import React, { useEffect, useState } from 'react'
import axios from "axios";
import { appConfig } from '../../../../tools/AppConfig'
import Waiting from '../../../waiting'
import './Sympl.css'

let lang = new URLSearchParams(window.location.search).get("lang");
if(lang == "ar"){
    lang = "AR"
}else{
    lang = "EN"
}

function Sympl(props) {

    const [waiting, setWaiting] = useState(true)
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    useEffect(() => {
        handle_pay()
    }, [])

    const handle_pay = () => {
        let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        var data = {
            "source": { 
                "subtype": "SYMPL_ONLINE", 
                "identifier": "SYMPL_ONLINE", 
                "accept_language": lang, 
            }, 
            "payment_token": props.payment_token
        }
        let jsonData = JSON.stringify(data);
        axios.post(
            url,
            jsonData,
            config
        )
        .then((resp)=>{
            window.location.href = resp.data.data.redirect_url;
        })
        .catch((err)=>{
            setWaiting(false)
            setError(true)
            if(err.response.data && err.response.data.error){
                setErrorMessage(err.response.data.error)
            }else{
                if(lang == "ar"){
                    setErrorMessage("هناك خطأ ما! حاول مرة اخرى.")
                }else{
                    setErrorMessage("Something went wrong! please try again.")
                }
            }
        });
    }

    return (
        <div className="sympl_iframe_container">
            {waiting ?
                <Waiting height='100px' />
            :
                error &&
                    <div className="alert alert-danger">
                        {errorMessage}
                    </div>
            }
        </div>
    )
}

export default Sympl